import ReactVisibilitySensor from "react-visibility-sensor";
import Counter from "../Counter/Counter";
import { useContext } from "react";
import { LangContext } from "../../App";

type Col = {
    year : string;
    value : number;
    color : string;
}

type ChartTwoProps = {
    title : string;
    cols : Col[];
    xAxis : string[];
    maxValue : number;
}

const ChartTwo = ({
    title,
    cols,
    xAxis,
    maxValue
} : ChartTwoProps) => {
    const { lang } = useContext(LangContext);

  return (
    <div className={`chart-two ${lang ? "rtl" : ""}`}>
        <h4 className="chart-title">{title}</h4>
        <ReactVisibilitySensor>
        {({isVisible} : any) => (
        <div className="col-group">
            {cols.map((item, index) => (
                <div className="column" key={index}>
                    <div className="label">{item.year}</div>
                    <div className="line-wrapper">
                    <div className={`line ${isVisible ? "visible" : ""} bg-${item.color}`} style={{ width: `${item.value * 100 / maxValue}%`}}>
                        <span><Counter counterValue={item.value} applyCounteClassName="" /></span>
                    </div>
                    </div>
                </div>
            ))}
        </div>

        )}
        </ReactVisibilitySensor>
        <div className="x-axis">
            {xAxis.map((item, index) => (
                <span key={index} className="x-label">{item}</span>
            ))}
        </div>
    </div>
  )
}

export default ChartTwo